<div class="programari-view">
    <div class="programari-top d-flex justify-content-between align-items-center gap-2 p-3">
        <div class="programari-title d-flex justify-content-between align-items-center gap-2">
            <mat-icon class="back-button" (click)="navigateBack()">chevron_left</mat-icon>
            <span>
                Programări {{moduleName}}
            </span>
        </div>
        <div class="d-flex flex-column flex-xl-row gap-2">
            <div class="params-select">
                <mat-form-field>
                    <mat-label>Locație</mat-label>
                    <mat-select [(ngModel)]="locatieActivaId" (selectionChange)="changeLocation()">
                        <mat-option *ngFor="let locatieActiva of locatiiActiveModul" [value]="locatieActiva.id">{{
                            locatieActiva.nume_locatie }}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div *ngIf="moduleId === 2" class="params-select">
                <mat-form-field>
                    <mat-label>Tip programare</mat-label>
                    <mat-select [(ngModel)]="tipProgramId" (selectionChange)="changeTipProgramActiv()">
                        <mat-option *ngFor="let tipProgram of tipuriProgramModul" [value]="tipProgram.id">{{
                            tipProgram.name }}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
    </div>

    <mat-sidenav-container [@.disabled]="true">
        <mat-sidenav mode="side" [opened]="viewing" disableClose>
            <div *ngIf="viewing && selectedId"
                class="d-flex flex-row align-items-center justify-content-between gap-2 panel-title">
                <div class="details">Detalii</div>
                <div>
                    <!-- <button mat-icon-button (click)="showHistory(selectedId)" matTooltip="Vezi istoricul">
                        <mat-icon>history</mat-icon>
                    </button>
                    <button mat-icon-button matTooltip="Șterge" color="warn" (click)="remove.emit(selectedId)">
                        <mat-icon>delete</mat-icon>
                    </button>
                    <button mat-icon-button matTooltip="Editează" color="primary" (click)="edit.emit(selectedId)">
                        <mat-icon>edit</mat-icon>
                    </button> -->
                    <button mat-icon-button (click)="closeView()" matTooltip="Închide">
                        <mat-icon>clear</mat-icon>
                    </button>
                </div>
            </div>
            <app-view-expansion-panel *ngIf="viewing && selectedAppointment && cerere"
                [appointment]="selectedAppointment" [cerere]="cerere"></app-view-expansion-panel>
        </mat-sidenav>
        <mat-sidenav-content>
            <mat-toolbar class="d-flex gap-2 justify-content-between"
                [ngClass]="{'toolbar-subtract-sidebar-width': selectedId}">
                <div class="d-flex gap-2 align-items-center">
                    <button mat-stroked-button (click)="today()">
                        Azi
                    </button>
                    <button mat-icon-button (click)="prevWeek()" color="primary" class="bg-white"
                        matTooltip="Săptămâna trecută">
                        <mat-icon>
                            keyboard_arrow_left
                        </mat-icon>
                    </button>
                    <button mat-icon-button (click)="nextWeek()" color="primary" class="bg-white"
                        matTooltip="Săptămâna viitoare">
                        <mat-icon>
                            keyboard_arrow_right
                        </mat-icon>
                    </button>
                    <span>{{formattedStartDateEndDate}}</span>
                </div>
                <div class="d-flex gap-2 align-items-center">
                    <button mat-icon-button (click)="getData()" matTooltip="Reîncarcă">
                        <mat-icon>refresh</mat-icon>
                    </button>
                    <button mat-icon-button color="primary" [matMenuTriggerFor]="settings" matTooltip="Setări">
                        <mat-icon>settings</mat-icon>
                    </button>
                    <mat-menu #settings="matMenu">
                        <button mat-menu-item (click)="toggleRejectedAppointments()">
                            <mat-icon [ngStyle]="{ opacity: hideRejectedAppointments ? 1 : 0}">check</mat-icon>
                            <span class="menu-text">Ascunde programările anulate</span>
                        </button>
                        <button mat-menu-item (click)="toggleWeekends()">
                            <mat-icon [ngStyle]="{ opacity: hideWeekends ? 1 : 0}">check</mat-icon>
                            <span class="menu-text">Ascunde weekend-urile</span>
                        </button>
                    </mat-menu>
                </div>
            </mat-toolbar>

            <div class="d-flex flex-row calendar">
                <div class="calendar-column" *ngFor="let day of days; trackBy: trackByFn">
                    <div class="calendar-header p-3">
                        <div class="day-of-week-short-text">
                            <small>{{formatMoment(day, dateFormats.dayOfWeek)}}</small>
                        </div>

                        <div class="day-of-week-short" [ngClass]="{'today': isToday(day)}">
                            <span>{{formatMoment(day, dateFormats.dateShort)}}</span>
                        </div>
                    </div>
                    <div class="calendar-time">
                        <div *ngFor="let hour of hours; trackBy: trackByFn">
                            <div *ngFor="let timespanStart of timespanStarts; trackBy: trackByFn"
                                class="timespan position-relative">
                                <ng-container *ngFor="let appointment of filterAppointments(appointments, day)">
                                    <div *ngIf="appointment.time_from === (hour + ':' + timespanStart)"
                                        class="appointment" [ngClass]="appointmentClass(appointment)"
                                        [ngStyle]="appointmentStyle(appointment)" matRipple
                                        (click)="getCerereInfo(appointment)">
                                        <div class="appointment-name">
                                            {{appointment.cerere_cetatean.nume}} {{appointment.cerere_cetatean.prenume}}
                                        </div>
                                        <div class="appointment-time">
                                            <small>{{appointment.time_from}} - {{appointment.time_end}}</small>
                                        </div>
                                    </div>
                                </ng-container>
                                <small>{{hour}}:{{timespanStart}}</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </mat-sidenav-content>
    </mat-sidenav-container>

    <div class="section-spinner position-absolute" *ngIf="isLoading || isLoadingAppointments">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>